// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"6683":"859b6e81","6751":"100065f3","7375":"859b6e81"}[chunkId] + ".chunk.css";
};